import { ControlFacet } from '../models/controls/ControlFacet';

export const copyLinkActionControl = new ControlFacet<{
  itemKey: string;
}, {
    isAvailable: boolean;
  }>('copyLinkActionControl');
